function EndreInfo() {
return(
<html></html>

)
}


export default EndreInfo;